import React, { useContext } from "react";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import logoLcn from "../../img/logo-c-path.png";
import logoMeso from "../../img/logo-lcss-meso.gif";

export const LCSSLogo = (props) => {
	const classes = props.classes;

	const { theme } = useContext(DiseaseGroupContext);

	switch (theme.group) {
		case "lcnuk":
			return (
				<img
					className={classes}
					src={logoLcn}
					alt="Critical Path Institute Logo"
				/>
			);
		case "meso":
		case "mesoperitoneal":
			return (
				<img
					className={classes}
					src={logoMeso}
					alt="Research Associates Logo"
				/>
			);
		default:
			return null;
	}
};
